import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { AngleDownLightGlyph } from '@acast-tech/decibel-glyphs';
import T from 'prop-types';
import { forwardRef, useRef } from 'react';
import styled from 'styled-components';
import { black16, black72 } from '../../styles/colors';
import { unit } from '../../styles/unit';
import { Icon } from '../Icon/Icon';
import { TextInput } from '../TextInput/TextInput';
import { SelectOption, valuePropType } from './SelectOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Placeholder = props => {
  return /*#__PURE__*/_jsx(SelectOption, Object.assign({
    value: "",
    disabled: true,
    hidden: true
  }, props));
};

const StyledSelect = /*#__PURE__*/styled.select.withConfig({
  displayName: "StyledSelect",
  componentId: "sc-3b4j4-0"
})(["padding-right:", ";text-overflow:ellipsis;min-width:0;&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000000;}"], unit(8));
const AngleDownIconContainer = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "AngleDownIconContainer",
  componentId: "sc-3b4j4-1"
})(["margin-left:-", ";padding-right:", ";color:", ";pointer-events:none;align-self:center;box-sizing:content-box;"], unit(6), unit(2), props => props.disabled ? black16 : black72);
const Select = /*#__PURE__*/forwardRef(function Select(_ref, forwardedRef) {
  let {
    disabled = false,
    glyph,
    invalid = false,
    placeholder,
    defaultValue,
    value,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["disabled", "glyph", "invalid", "options", "placeholder", "defaultValue", "value", "children"]);

  const {
    current: selectedDefaultValue
  } = useRef(value === undefined && defaultValue === undefined && placeholder ? '' : defaultValue);
  return /*#__PURE__*/_jsxs(TextInput, Object.assign({
    as: StyledSelect,
    value: value,
    defaultValue: selectedDefaultValue,
    invalid: invalid,
    disabled: disabled,
    glyph: glyph,
    type: null,
    addonEnd: /*#__PURE__*/_jsx(AngleDownIconContainer, {
      disabled: disabled,
      glyph: AngleDownLightGlyph,
      size: "xsmall"
    }),
    ref: forwardedRef
  }, restProps, {
    children: [placeholder && /*#__PURE__*/_jsx(Placeholder, {
      children: placeholder
    }), children]
  }));
});
Select.propTypes = Object.assign({}, TextInput.propTypes, {
  placeholder: T.string,
  defaultValue: valuePropType,
  value: valuePropType,
  children: T.node
});
export { Select, SelectOption };